import AttendanceModel from '../../models/attendance/attendance.model';
import languageModel from '../../models/language.model';
import loginModel from '../../models/login.model';
import { Dialog } from 'construct-ui';
import ViewBase from '../view-base.view';
import moment from 'moment';
import paginationComponent from '../../components/pagination/pagination.component';
import WidgetContainerComponent from "../../components/widget/widget-container.component";
import SmallTextWidgetComponent from "../../components/widget/small-text-widget.component";
import AttendanceWorkTypePieChartComponent from "../../components/charts/pie/attendance-work-type-pie-chart.component";
import AttendanceScheduledVisitsDonutChartComponent from "../../components/charts/pie/attendance-scheduled-visits-donut-chart.component";
import DatePickerComponent from '../../components/date-picker/date-picker.component';
import UserBadgeComponent from '../../components/common/user-badge.component';
import { formats as FORMATS } from '../../config/constants';
import SelectUserComponent from '../../components/user/select-user.component';
import MultiSelectComponent from '../../components/multi-select/multi-select.component';
import SelectSiteGroupComponent from '../../components/site/select-site-group.component';
import userSearchModal from '../../models/common/user-search.modal';
import codeMasterModel from '../../models/common/code-master.model'
import AttendanceExcelUploadView from './attendance-excel-upload.view';
import AttendanceExcelDownloadView from './attendance-excel-download.view';
import { codeMasterType } from "../../config/constants";

export default function AttendanceView() {
  ViewBase.call(this);

  const DEFAULT_PAGINATION = Object.freeze({
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0
  });

  const DEFAULT_FILTER_PARAMS = Object.freeze({
    // date: moment().format(FORMATS.dateFormat),
    fromDate: moment().subtract(1, 'week').format(FORMATS.dateFormat),
    toDate: moment().format(FORMATS.dateFormat),
    selectedWorkType: null,
    selectedAttendanceAbnormalType: null,
    selectedUsers: Object.freeze([]),
    selectedUserRoles: Object.freeze([]),
    selectedSiteGroups: Object.freeze([]),
    selectedBUs: Object.freeze([]),
    selectedDivisionGroup: Object.freeze([]),
    selectedSalesForceType: Object.freeze([])
  });

  let inputFilter;

  const DEFAULT_EXPORT_PARAMS = {
    _fromDate: '',
    _toDate: '',

    get fromDate() {
      this._fromDate = this._fromDate || inputFilter?.fromDate || moment().subtract(1, 'week').format(FORMATS.dateFormat);
      return this._fromDate;
    },

    get toDate() {
      this._toDate = this._toDate || inputFilter?.toDate || moment().format(FORMATS.dateFormat);
      return this._toDate;
    },

    set fromDate(_newFromDate) {
      this._fromDate = _newFromDate || this._fromDate;
    },

    set toDate(_newToDate) {
      this._toDate = _newToDate || this._toDate;
    },

    get fromDateForAPI() {
      this._fromDate = this._fromDate || inputFilter?.fromDate || moment().subtract(1, 'week').format(FORMATS.dateFormat);
      return moment(this._fromDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat);
    },

    get toDateForAPI() {
      this._toDate = this._toDate || inputFilter?.toDate || moment().format(FORMATS.dateFormat);
      return moment(this._toDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat);
    },
  };
  
  inputFilter = structuredClone(Object.assign({}, DEFAULT_PAGINATION, DEFAULT_FILTER_PARAMS, DEFAULT_EXPORT_PARAMS));

  let workTypeTotal = 0;
  let lateData, earlyLeaveData, noShowData;
  let lstAttendance = [];
  let lstWorkType = [];
  let lstCheckInOut = [];
  let lstAbnormal = [];
  let lstUserRole = [];
  let salesForceTypeList = [];
  let divisionGroupList = [];
  let BUList = [];
  let isExcelUploadModalOpen = false;
  let isExcelDownloadModalOpen = false;

  let events = {
    onWorkTypeChartDataChanged: (_data) => { },
    onCheckInOutChartDataChanged: (_data) => { }
  };

  let resetAttendanceList = () => {
    lstAttendance = [];
  }

  let resetPagination = () => {
    inputFilter = structuredClone(Object.assign({}, inputFilter, DEFAULT_PAGINATION));
  }

  let extractFilterToQueryParams = () => {
    // console.log('inputFilter======>', inputFilter)
    return Object.assign(
      {
        pageSize: inputFilter.pageSize,
        pageIndex: inputFilter.pageIndex
      },
      _.isEmpty(inputFilter.selectedWorkType) ? null : { workType: inputFilter.selectedWorkType.workTypeCode },
      _.isEmpty(inputFilter.selectedAttendanceAbnormalType) ? null : { attendanceAbnormalType: inputFilter.selectedAttendanceAbnormalType },
      _.isEmpty(inputFilter.selectedUsers) ? null : { userId: inputFilter.selectedUsers.map(u => u.userID).join('^') },
      _.isEmpty(inputFilter.selectedUserRoles) ? null : { userRoleCode: inputFilter.selectedUserRoles.map(r => r.code).join('^') },
      _.isEmpty(inputFilter.selectedSiteGroups) ? null : { siteGroupId: inputFilter.selectedSiteGroups.map(g => g.code).join('^') },
      _.isEmpty(inputFilter.selectedBUs) ? null : { bu: inputFilter.selectedBUs.join('^') },
      _.isEmpty(inputFilter.selectedSalesForceType) ? null : { saleForceType: inputFilter.selectedSalesForceType.join('^') },
      _.isEmpty(inputFilter.selectedDivisionGroup) ? null : { divisionGroup: inputFilter.selectedDivisionGroup.join('^') },
      inputFilter.fromDate ? { fromDate: moment(inputFilter.fromDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat) } : null,
      inputFilter.toDate ? { toDate: moment(inputFilter.toDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat) } : null,
    );
  }

  let getAttendanceDetails = () => {
    // Skip API call if count is 0
    if (workTypeTotal === 0 || (inputFilter.selectedWorkType && inputFilter.selectedWorkType.count === 0)) {
      resetAttendanceList();
      return;
    }

    // Reset pagination
    resetPagination();
    return getAttendance();
  }

  let getAttendance = () => {
    this.showLoading();
    resetAttendanceList();

    return AttendanceModel.getAttendance(extractFilterToQueryParams())
      .then((result) => {
        lstAttendance = result.data;
        inputFilter.totalCount = result.total;
        inputFilter.pageIndex = result.pageIndex;
        inputFilter.pageSize = result.pageSize;
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    inputFilter.pageIndex = pageIndex;
    inputFilter.pageSize = pageSize;
    getAttendance();
  }

  let onPageChanged = (pageIndex) => {
    inputFilter.pageIndex = pageIndex;
    getAttendance();
  }

  let getUserRoleList = () => {
    lstUserRole = [];
    return userSearchModal.getUserRoleList(
      (result) => {
        lstUserRole = result;
      },
      (error) => {
        this.handleError(error);
      }
    )
  }

  let getWorkType = (queryParams) => {
    return AttendanceModel.getAttendanceWorkType(queryParams)
      .then((result) => {
        lstWorkType = [];
        workTypeTotal = 0;

        lstWorkType = result;
        lstWorkType.map(wt => {
          workTypeTotal += wt.count;
        })
        events.onWorkTypeChartDataChanged(lstWorkType);
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  let getCheckInOut = (queryParams) => {
    return AttendanceModel.getAttendanceCheckInOut(queryParams)
      .then((result) => {
        lstCheckInOut = result;
        events.onCheckInOutChartDataChanged(lstCheckInOut);
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  let getAbnormal = (queryParams) => {
    return AttendanceModel.getAttendanceAbnormal(queryParams)
      .then((result) => {
        lstAbnormal = result;
        lateData = result.find(o => o.attendanceAbnormalTypeCode === "001");
        earlyLeaveData = result.find(o => o.attendanceAbnormalTypeCode === "002");
        noShowData = result.find(o => o.attendanceAbnormalTypeCode == "003")
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  const getBU = () => {
    const country = loginModel.credentials.country;
    codeMasterModel.getByCategoryV2({ category: codeMasterType.bu, countryCode: country?.code })
      .then((result) => {
        if (result) {
          BUList = result;
        }
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  const getSalesForceType = () => {
    const country = loginModel.credentials.country;
    codeMasterModel.getByCategoryV2({ category: codeMasterType.salesForceType, countryCode: country?.code })
      .then((result) => {
        if (result) {
          salesForceTypeList = result;
        }
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  const getDivisionGroup = () => {
    const country = loginModel.credentials.country;
    codeMasterModel.getByCategoryV2({ category: codeMasterType.divisionGroup, countryCode: country?.code })
      .then((result) => {
        if (result) {
          divisionGroupList = result;
        }
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  let searchAttendance = () => {
    this.showLoading();

    let queryParams = extractFilterToQueryParams();
    Promise.allSettled([getWorkType(queryParams), getCheckInOut(queryParams), getAbnormal(queryParams)])
      .then(getAttendanceDetails)
      .catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  let openExcelUploadModal = () => {
    isExcelUploadModalOpen = true;
  }

  let closeExcelUploadModal = () => {
    isExcelUploadModalOpen = false;
  }

  let openExcelDownloadModal = () => {
    isExcelDownloadModalOpen = true;
  }

  let closeExcelDownloadModal = () => {
    isExcelDownloadModalOpen = false;
  }

  function getStringValue(obj, str) {
    let strValue = "";
    if (obj) {
      if (str == "schedule") {
        if (obj.startTime != null || obj.endTime != null) {
          strValue = obj.startTime == null ? "" : obj.startTime;
          strValue = strValue + " - ";
          strValue += obj.endTime == null ? "" : obj.endTime;
        }

        if (obj.siteName != null && obj.workType === "Work"  && obj.siteName != "" && strValue != "") {
          strValue += ` ( Store: ${obj.siteName} )`;
        } else {
          if ((obj.workType === "Training" || obj.workType === "Roadshow" || obj.workType === "Others" || obj.workType === "Other Work") && obj.remarks) {
            strValue += ` ( Remarks: ${obj.remarks} )`
          } 
        }
        if (strValue == "") {
            strValue = "-";
        }
      } else if (str == "inout") {
        if (obj.checkInTime != null || obj.checkOutTime != null) {
          strValue = obj.checkInTime == null ? "" : obj.checkInTime;
          strValue = strValue + " - ";
          strValue += obj.checkOutTime == null ? "" : obj.checkOutTime;
        }

        if (obj.siteName != null && obj.siteName != "" && strValue != "") {
          strValue += " (" + obj.siteName + ")";
        } else {
          strValue = "-";
        }

      }
    }
    return strValue;
  }

  let _clearFilter = () => {
    inputFilter = Object.assign({}, DEFAULT_PAGINATION, DEFAULT_FILTER_PARAMS, DEFAULT_EXPORT_PARAMS);
    searchAttendance();
  }

  return {
    oninit: () => {
      getUserRoleList();
      searchAttendance();
      getBU();
      getSalesForceType();
      getDivisionGroup();
    },
    view: () => {
      return [
        m('.row',
          m('.col-12.attendance',
            // Search section
            m('.card.mb-3',
              m('.card-body',
                m('.row.g-4',
                  m('.col-md-3.col-xl-3',
                    m("label.form-label", languageModel.getText("LT00000132", "Date")),
                    m(DatePickerComponent, {
                      class: 'form-control',
                      isRange: true,
                      // date: inputFilter.date, // default date
                      dateStart: inputFilter.fromDate,
                      dateEnd: inputFilter.toDate,
                      onselect: (e) => {
                        inputFilter.fromDate = moment(e.detail.start).format(FORMATS.dateFormat);
                        inputFilter.toDate = moment(e.detail.end).format(FORMATS.dateFormat);
                      }
                    })
                  ),
                  m('.col-md-3.col-lg-3',
                    m('label.form-label', this.getText("LT00000219", "Users")),
                    m(SelectUserComponent, {
                      default: {
                        userStatusCode: '0001'
                      },
                      onSelect: (u) => {
                        inputFilter.selectedUsers = u;
                      },
                      selectedUserList: inputFilter.selectedUsers,
                    })
                  ),
                  m('.col-md-3.col-lg-3',
                    m('label.form-label', this.getText("LT00000060", "User Role")),
                    m(MultiSelectComponent, {
                      items: lstUserRole,
                      selectedItems: inputFilter.selectedUserRoles,
                      onSelect: (u) => {
                        inputFilter.selectedUserRoles = u;
                      }
                    })
                  ),
                  m('.col-md-3.col-lg-3',
                    m('label.form-label', this.getText("LT00000072", "Site Group")),
                    m(SelectSiteGroupComponent, {
                      selectedItems: inputFilter.selectedSiteGroups,
                      onChange: (g) => {
                        inputFilter.selectedSiteGroups = g;
                      }
                    })
                  ),
                  m('.col-md-3.col-lg-3',
                    m('label.form-label', this.getText("LT00000239", "BU")),
                    m(MultiSelectComponent, {
                      items: BUList,
                      selectedItems: inputFilter.selectedBUs,
                      keyOnly: true,
                      filterable: false,
                      onSelect: (v) => {
                        inputFilter.selectedBUs = v;
                      }
                    })
                  ),
                  m('.col-md-3.col-lg-3',
                    m('label.form-label', this.getText("LT00000192", "Sales Force Type")),
                    m(MultiSelectComponent, {
                      items: salesForceTypeList,
                      selectedItems: inputFilter.selectedSalesForceType,
                      keyOnly: true,
                      filterable: false,
                      onSelect: (v) => {
                        inputFilter.selectedSalesForceType = v;
                      }
                    }),
                  ),
                  m('.col-md-3.col-lg-3',
                    m('label.form-label', this.getText("LT00000246", "Division Group")),
                    m(MultiSelectComponent, {
                      items: divisionGroupList,
                      selectedItems: inputFilter.selectedDivisionGroup,
                      keyOnly: true,
                      filterable: false,
                      onSelect: (v) => {
                        inputFilter.selectedDivisionGroup = v;
                      }
                    }),
                  ),
                  m('.col-12.d-flex.justify-content-end.gap-2',
                    m('button.btn.btn-primary', { onclick: searchAttendance }, this.getText("LT00000001", "Search")),
                    m('button.btn.btn-white', { onclick: _clearFilter }, this.getText("LT00000031", "Clear")),
                  ),
                )
              )
            ),

            // Widgets
            m(WidgetContainerComponent, { class: 'mb-3' }, [
              m('.d-flex.flex-wrap.gap-3',
                m('div.flex-fill',
                  m('.d-flex.align-items-stretch.flex-wrap.gap-3',
                    m('.flex-grow-1',
                      m('.card.widget-component', m('.card-body',
                        lstWorkType.length > 0 &&
                        m(AttendanceWorkTypePieChartComponent, { data: lstWorkType, events: events })
                      )),
                    ),
                    m('.flex-grow-1',
                      m('.card.widget-component', m('.card-body',
                        lstCheckInOut.length > 0 &&
                        m(AttendanceScheduledVisitsDonutChartComponent, { data: lstCheckInOut, events: events })
                      )),
                    )
                  ),
                  // Filter section
                  m('.card.mt-3',
                    m('.card-body.p-0',
                      m('.attendance-wt-filter-wrapper',
                        m(".attendance-wt-filter", {
                          class: inputFilter.selectedWorkType ? '' : 'selected',
                          onclick: () => {
                            inputFilter.selectedWorkType = null;
                            inputFilter.selectedAttendanceAbnormalType = null;
                            getAttendanceDetails();
                          }
                        },
                          m(".attendance-wt-filter__title",
                            languageModel.getText("LT00000046", "Total")
                          ),
                          m(".attendance-wt-filter__total",
                            workTypeTotal
                          ),
                        ),
                        lstWorkType.map(wt =>
                          [
                            m(".attendance-wt-filter", {
                              class: inputFilter.selectedWorkType?.workTypeName === wt.workTypeName ? 'selected' : '',
                              onclick: () => {
                                inputFilter.selectedWorkType = wt;
                                inputFilter.selectedAttendanceAbnormalType = null;
                                getAttendanceDetails();
                              },
                            },
                              m(".attendance-wt-filter__title",
                                wt.workTypeName
                              ),
                              m(".attendance-wt-filter__total",
                                wt.count
                              ),
                            ),
                          ]
                        )
                      ),
                    ),
                  )
                ),
                m('.Small-Text-Widget-Component.gap-3',
                  lstAbnormal.length > 0 && [
                    m(SmallTextWidgetComponent,
                      {
                        handleFilterAbnormalTypeAttendance: () => {
                          inputFilter.selectedWorkType = null;
                          inputFilter.selectedAttendanceAbnormalType = lateData.attendanceAbnormalTypeCode;
                          getAttendanceDetails();
                        },
                        class: inputFilter.selectedAttendanceAbnormalType && inputFilter.selectedAttendanceAbnormalType === lateData.attendanceAbnormalTypeCode ? 'home-widget_late-stat home-widget_late-stat-active' :  'home-widget_late-stat',
                        title: lateData.attendanceAbnormalTypeName,
                        mainText: String(lateData.count),
                        secondaryText: lateData.percent + '%',
                        additionalText: 'Avg. ' + lateData.average + ' min',
                      }
                    ),
                    m(SmallTextWidgetComponent,
                      {
                        handleFilterAbnormalTypeAttendance: () => {
                          inputFilter.selectedWorkType = null;
                          inputFilter.selectedAttendanceAbnormalType = earlyLeaveData.attendanceAbnormalTypeCode;
                          getAttendanceDetails();
                        },
                        class: inputFilter.selectedAttendanceAbnormalType && inputFilter.selectedAttendanceAbnormalType === earlyLeaveData.attendanceAbnormalTypeCode ?  'home-widget_early-leave-stat home-widget_early-leave-stat-active' : 'home-widget_early-leave-stat',
                        title: earlyLeaveData.attendanceAbnormalTypeName,
                        mainText: String(earlyLeaveData.count),
                        secondaryText: earlyLeaveData.percent + '%',
                        additionalText: 'Avg. ' + earlyLeaveData.average + ' min',
                      }
                    ),
                    m(SmallTextWidgetComponent,
                      {
                        handleFilterAbnormalTypeAttendance: () => {
                          inputFilter.selectedWorkType = null;
                          inputFilter.selectedAttendanceAbnormalType = noShowData.attendanceAbnormalTypeCode;
                          getAttendanceDetails();
                        },
                        class: inputFilter.selectedAttendanceAbnormalType && inputFilter.selectedAttendanceAbnormalType === noShowData.attendanceAbnormalTypeCode ? 'home-widget_no-show-stat home-widget_no-show-stat-active' : 'home-widget_no-show-stat',
                        title: noShowData.attendanceAbnormalTypeName,
                        mainText: String(noShowData.count),
                        secondaryText: noShowData.percent + '%',
                        additionalText: 'Avg. ' + noShowData.average + ' min',
                      }
                    ),
                  ]
                ),
              ),
            ]),

            //List(attendance details)
            m('.card',
              m('.card-body',
                m('.d-flex.justify-content-end.gap-3.mb-2',
                  loginModel.credentials?.admin &&
                  m('a.btn.btn-primary',
                    {
                      onclick: openExcelUploadModal
                    },
                    m('i.bi.bi-file-earmark-arrow-up-fill'), this.getText("LT00000197", "Excel Upload"),
                  ),
                  m('a.btn.btn-primary',
                    {
                      class: lstAttendance?.length > 0 ? '' : 'disabled',
                      onclick: openExcelDownloadModal
                    },
                    m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                  )
                ),
                m('.row',
                  m(".col-12.p-0",
                    m(".table-responsive",
                      m("table.table", [
                        m("thead.thead-bggrey",
                          m("tr.align-middle", [
                            m("th", { "scope": "col", 'style': 'min-width: 160px; width: 200px;' }, languageModel.getText("LT00000011", "Name")),
                            m("th", { "scope": "col" }, languageModel.getText("LT00000149", "Work Type")),
                            // m("th", { "scope": "col" }, languageModel.getText("LT00000367", "Sub-category")),
                            m("th", { "scope": "col" }, languageModel.getText("LT00000015", "Status")),
                            m("th", { "scope": "col" }, this.getText("LT00000132", "Date")),
                            m("th", { "scope": "col" }, languageModel.getText("LT00000153", "Schedule")),
                            m("th", { "scope": "col", "colspan": "3" }, languageModel.getText("LT00000213", "Check In/Out")),
                          ])
                        ),
                        m("tbody",
                          (lstAttendance.length === 0) &&
                          m("tr", { "class": "align-middle" },
                            m("td", { "colspan": "5" }, languageModel.getText("EM00000141", "No records found."))
                          ),
                          lstAttendance.length > 0 &&
                          lstAttendance.map(att => [
                            m("tr.align-middle", [
                              m("td", { "style": { "max-width": "240px", "white-space": "normal" } },
                                m(UserBadgeComponent,
                                  {
                                    image: att.userPhoto,
                                    imageSize: '40px',
                                    flexGap: '0.5rem'
                                  },
                                  m('span', { style: 'font-size: 0.875rem; word-break: break-word;' }, att.userName)
                                ),
                              ),
                              m("td", att.workType  + `${(att.workType === "Leave" || att.workType === "Day Off") && att.remarks ? ' (' + att.remarks + ')' : "" }`),
                              // m("td", att.leaveDayOffTypeName),
                              m("td", att.visitStatus),
                              m("td", att.scheduleDate ? moment(att.scheduleDate).format(FORMATS.dateFormat) : ""),
                              m("td", { "style": { "max-width": "250px", "white-space": "initial" } }, getStringValue(att, "schedule")),
                              m("td", { "style": { "max-width": "250px", "white-space": "initial" } }, getStringValue(att, "inout")),
                              m("td", { "style": { "width": "5%" } },
                                (att.checkInPhoto == null || att.checkInPhoto == "") ? "" :
                                  m("img", { "src": att.checkInPhoto, "title": att.userName, "alt": att.userName, "class": "userImg-circle", "style": { "max-width": "33px", "overflow": "hidden", "object-fit": "contain" } })
                              ),
                              m("td", { "style": { "width": "5%" } },
                                (att.checkOutPhoto == null || att.checkOutPhoto == "") ? "" :
                                  m("img", { "src": att.checkOutPhoto, "title": att.userName, "alt": att.userName, "class": "userImg-circle", "style": { "max-width": "33px", "overflow": "hidden", "object-fit": "contain" } })
                              ),
                            ]),
                          ]),
                        )
                      ])
                    ),
                    lstAttendance.length > 0 &&
                    m(".px-3",
                      m(paginationComponent, { currentPage: inputFilter.pageIndex, pageSize: inputFilter.pageSize, totalItems: inputFilter.totalCount, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                    )
                  )
                )
              )
            )
            //End List
          ),
        ),
        isExcelUploadModalOpen &&
        m(Dialog, {
          class: 'modal-body-overflow-visible',
          closeOnOutsideClick: false,
          isOpen: isExcelUploadModalOpen,
          onClose: closeExcelUploadModal,
          title: this.getText('LT00000740', 'Check In/Out Time Update'),
          content: m(AttendanceExcelUploadView, {
            onClose: (o) => { isExcelUploadModalOpen = o; },
            triggerRefresh: (needRefresh) => {
              if (needRefresh) {
                searchAttendance();
              }
            },
          }),
        }),
        isExcelDownloadModalOpen &&
        m(Dialog, {
          class: 'modal-body-overflow-visible',
          closeOnOutsideClick: false,
          isOpen: isExcelDownloadModalOpen,
          onClose: closeExcelDownloadModal,
          title: this.getText('LT00000741', 'Attendance Download'),
          content: m(AttendanceExcelDownloadView, {
            data: extractFilterToQueryParams(),
            onClose: (o) => { isExcelDownloadModalOpen = o; },
          }),
        }),
        this.getBaseViews()
      ];
    },
  };
}
